import React from 'react';

const DashboardSection = ({
  title,
  titleCentered = true,
  contentCentered = false,
  contentEnd = true,
  titleClassName,
  children,
}: {
  title: string | React.ReactNode;
  titleCentered?: boolean;
  contentCentered?: boolean;
  contentEnd?: boolean;
  titleClassName?: string;
  children: React.ReactNode;
}) => {
  const cardStyles = {
    base: 'bg-white rounded-lg border border-custom-lightSilver shadow-[2px_2px_4px_rgba(0,0,0,0.04)]',
    height: 'h-full',
    padding: 'p-6',
    title: 'text-md font-semibold text-custom-black mb-4',
  };

  return (
    <div className={`${cardStyles.base} ${cardStyles.height}`}>
      <div className={cardStyles.padding}>
        <h3 className={`${cardStyles.title} ${titleCentered ? 'text-center' : 'text-start'} ${titleClassName || ''}`}>
          {title}
        </h3>
        <div
          className={`flex ${
            contentCentered
              ? 'justify-center items-center'
              : contentEnd
              ? 'justify-center items-end'
              : 'justify-center items-start'
          } h-[calc(100%-2rem)] w-full`}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export default DashboardSection;
